// extracted by mini-css-extract-plugin
export var blueGhost = "xaF0h9ese0xnTUK6vPhy uCstumKrF0UzyLFCCvIx";
export var blueUnderlined = "uCstumKrF0UzyLFCCvIx";
export var colourInherit = "Z472R0FtmrgVvoj2svIi";
export var focusVisible = "wlfSfsybiNuRxqCrdoZ_";
export var icon = "KITaocaXsRNUoouEiVYZ";
export var root = "vtWA7nttAxJvgOlEehEK";